<template>
<div class="base-form">
    <form ref="form" @submit.prevent="onSubmit" class="field has-addons">
        <div class="control text-control is-expanded">
            <textarea-autosize
                @keydown.native.enter.exact.prevent="trySubmit"
                @keydown.native.ctrl.enter.exact.prevent="trySubmit"
                v-bind="$attrs"
                v-on="inputListeners"
                :value="value"
                :minLength="minLength"
                :maxLength="maxLength"
                :minHeight="minHeight"
                :maxHeight="maxHeight"
                rows="1"
                class="textarea is-primary is-small"
                :class="{ 'is-cooling-down': isCoolingDown }"
                :disabled="disabled || isLoading"
                required/>
        </div>
        <div class="control btn-control">
            <span v-show="showTextLimit" class="text-limit">
                {{ `${value.length}/${maxLength}` }}
            </span>
            <button
                :disabled="disabled"
                :class="{ 'is-loading': isLoading }"
                class="button submit-button is-primary is-small">
                <slot name="buttonText"/>
            </button>
        </div>
    </form>
</div>
</template>

<script>
import * as C from '@shared/constants'
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'BaseForm',
    inheritAttrs: false,
    props: {
        value: String,
        disabled: Boolean,
        isLoading: Boolean,
        isCoolingDown: Boolean,
        minLength: {
            type: Number,
            default: 3,
        },
    },
    data: () => ({
        // Numbers are for .textarea.is-small
        minHeight: 30, // 1 row
        maxHeight: 195, // ~9 rows
    }),
    computed: {
        ...mapState(['channel']),
        ...mapGetters(['isBroadcaster']),
        maxLength: vm => vm.isBroadcaster ? 10000 : vm.channel.suggestionMaxLength,
        showTextLimit: vm => vm.value.length >= vm.maxLength * 0.9,
        inputListeners: vm => ({
            ...vm.$listeners,
            // for transparent v-model with the parent component
            input: event => vm.$emit('input', event)
        })
    },
    methods: {
        onSubmit () {
            // html5 required allows blank spaces...
            if (this.value.length < this.minLength) { return }

            this.$emit('submit')
        },
        trySubmit () {
            const isValid = this.$refs.form?.reportValidity()
            if (isValid) {
                this.onSubmit()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.base-form {
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden; // hacky way to hide box-shadows on :active input & button
}
.field {
    width: 100%;
}

.text-control {
    overflow: hidden; // hacky way to hide box-shadows on :active input & button
    .textarea {
        // use bulma's padding CSS for .input. It's slimmer
        padding: calc(.5em - 1px) calc(.75em - 1px);
        border-radius: 0;
        &:active {
            box-shadow: none !important;
        }
        &.is-cooling-down::placeholder {
            color: #333;
        }
    }
}

.btn-control {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    .button {
        border-radius: 0;
    }
    .text-limit {
        @include flex-center-children;
        flex: 1;
        font-size: 0.7rem;
        text-align: center;
        margin: 0;
    }
}

.submit-button {
    background-color: var(--theme-color) !important;
    color: var(--theme-color-contrast);
}
</style>
